module.exports = " <div class=header> <div class=container> <div class=header-logo> <a href=#!><span class=\"mega-octicon octicon-mark-github\"></span></a> </div> <form> <label for=repoLink>Repo Link:</label> <input id=repoLink class=form-control type=text placeholder=https://github.com/xiaoluoboding/repository-tree v-model=inputValue> <span class=input-group-button> <button type=button class=\"btn btn-primary\" @click=getTree>Generate</button> </span> </form> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
 ** module id = 130
 ** module chunks = 0
 **/